import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'yo-dx-tab-menu',
  templateUrl: './dx-tab-menu.component.html',
  styleUrls: ['./dx-tab-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class DxTabMenuComponent {

  @Input() items: any[] = [];
  @Input() selectedItem: any;
  @Input() width = '100%';
  @Input() marginBottom = '24px';
  @Input() buttonSize = '38px';
  @Input() buttonRadius = '3px';
  @Input() buttonMargin = '0 6px 6px';
  @Output() itemClick = new EventEmitter<any>();

  onItemClick(event: any): void {
    this.itemClick.emit(event);
  }
}
